var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v("Shipment Summary "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTables),
      expression: "showTables"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "margin-left": "83%",
      "font-size": "20px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openPopUp()
      }
    }
  })]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Prediction"
    },
    model: {
      value: (_vm.showmodal),
      callback: function($$v) {
        _vm.showmodal = $$v
      },
      expression: "showmodal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Prediction")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', [_c('label2', [_vm._v("Allocation : ")]), _vm._v(" "), _vm._l((_vm.allocation), function(item) {
    return _c('li', [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label2', [_vm._v("OFD : ")]), _vm._v(" "), _vm._l((_vm.ofd), function(item) {
    return _c('li', [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label2', [_vm._v("POD (Status Update) : ")]), _vm._v(" "), _vm._l((_vm.pod), function(item) {
    return _c('li', [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment No")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentNo),
      expression: "shipmentNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "shipmentNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter / Scan Shipment No",
      "autocomplete": "off",
      "name": "shipmentNo"
    },
    domProps: {
      "value": (_vm.shipmentNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentNo')),
      expression: "errors.has('shipmentNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter shipping id.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mr-2 mt-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger mt-2",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSubmitLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSubmitLoading = $event
      }
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTables),
      expression: "showTables"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('legend', [_vm._v(" Lastmile F/W ")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm"
  }, [_c('h6', {
    staticClass: "header-label1"
  }, [_vm._v("Runsheet Summary : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.lastRunsheet.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastRunsheet), function(data, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "else": ""
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.HubId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.uniquecode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.userprocess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NDRCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Flyerbarcode))])])
  })], 2)]), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "header-label1"
  }, [_vm._v("Lastmile Summary : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.isPrexo) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Prexo ID")])]) : _vm._e(), _vm._v(" "), (_vm.isPrexo) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Prexo Shipping ID")])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.lastSummary.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastSummary), function(data, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "else": ""
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OriginHubID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentHubID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.FinalDestinationID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientBusinessConfigration))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeliveryCode))]), _vm._v(" "), (_vm.isPrexo) ? _c('td', [_vm._v(_vm._s(data.PrexoId))]) : _vm._e(), _vm._v(" "), (_vm.isPrexo) ? _c('td', [_vm._v(_vm._s(data.PrexoShippingId))]) : _vm._e()])
  })], 2)])]), _c('br')], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTables),
      expression: "showTables"
    }]
  }, [_c('legend', [_vm._v(" ShipmentUpdate F/W : ")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm"
  }, [_c('h6', {
    staticClass: "header-label1"
  }, [_vm._v("ShipmentUpdate : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.ProcessCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.UniqueCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.OriginHubID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.CurrentHubID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.FinalDestinationID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.NotificationType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.NotificationStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.RTOHubId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentupdateData.IsReversePick))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "header-label1"
  }, [_vm._v("Transaction Logs : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(11), _vm._v(" "), _c('tbody', [(_vm.transactions.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.transactions), function(data, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "else": ""
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProcessLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(data.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedBy))])])
  })], 2)])], 1)])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("HubId")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Uniquecode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Userprocess")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("NDR Code")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Flyer Barcode")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingId")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin HubID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current HubID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Final DestinationID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ClientBusinessConfigration")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Code")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UserProcess")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ProcessCode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UniqueCode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin HubID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current HubID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Final Destination ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Notification Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Notification Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("RTO Hub Id")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("IsReversePick")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("BagNo")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Process Location")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current Location")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Process")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created By")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025b0304","hasScoped":false}!./src/views/components/ShipmentSummary/ShipmentSummary.component.html
// module id = 1346
// module chunks = 1